import {RootConverter} from './root.converter';

export abstract class HttpModelConverter<T> extends RootConverter<T, T> {

    protected doConversion(src: T): T {
        // console.log(['entity to convert', src]);
        const result: T = Object.assign(this.createInstance(), src);
        this.enrichObject(result, src);
        return result;
    }

    protected abstract createInstance(): T;
    protected abstract enrichObject(result: T, src: T);
}
